import { indexProjectInvestmentsOperation } from "@api/services/investments"

const listProjectInvestments = async (request, projectId) => {
  // TODO: Might need to consider pagination here to pull all project transactions.
  const { data: projectInvestments } = await request(indexProjectInvestmentsOperation, { projectId })

  return projectInvestments
}

export default listProjectInvestments
